module.exports = __webpack_public_path__ + "img/Balance-3.cc091525.jpg";